import classnames from 'classnames'

import { Field } from '../../../Field'
import { COLOR_PICKER_DEFAULT_HEX } from '../../ColorPicker.constants'
import { isColorFormatHex } from '../../ColorPicker.utils'
import { getRgbFromHex } from '../ColorPickerPopover.utils'

import { useColorPickerPopoverPreview } from './ColorPickerPopoverPreview.hooks'
import { ColorPickerPopoverPreviewHexInput } from './ColorPickerPopoverPreviewHexInput'
import { ColorPickerPopoverPreviewReadonly } from './ColorPickerPopoverPreviewReadonly'
import { ColorPickerPopoverPreviewRgbInputs } from './ColorPickerPopoverPreviewRgbInputs'
import { ColorPickerPopoverPreviewValueTrigger } from './ColorPickerPopoverPreviewValueTrigger'

import * as styles from './ColorPickerPopoverPreview.module.css'

function ColorPickerPopoverPreview({
  active,
  color,
  colorFormat,
  editable = true,
  info,
  isPopoverOpen,
  label,
  multiColor,
  onManualColorChange,
}) {
  const rowClassName = classnames(styles.staticPreview, {
    [styles.active]: active,
    [styles.multicolor]: multiColor,
  })

  const rgb = getRgbFromHex(color || COLOR_PICKER_DEFAULT_HEX)

  const {
    handleBChange,
    handleBFocus,
    handleGChange,
    handleGFocus,
    handleHexInputBlur,
    handleHexInputChange,
    handleHexInputFocus,
    handleRChange,
    handleRFocus,
    handleRgbChannelBlur,
    handleValueTextTriggerClick,
    handleValueTextTriggerKeyDown,
    hexInputFocused,
    isValueInputFocused,
    rgbB,
    rgbFocusedChannel,
    rgbG,
    rgbGroupRef,
    rgbInputRef,
    rgbR,
    text,
    valueInputRef,
  } = useColorPickerPopoverPreview({
    color,
    colorFormat,
    isPopoverOpen,
    onManualColorChange,
  })

  return !editable || !onManualColorChange ? (
    <ColorPickerPopoverPreviewReadonly
      className={rowClassName}
      color={color}
      colorFormat={colorFormat}
      info={info}
      label={label}
    />
  ) : (
    <div className={rowClassName}>
      <Field
        className={styles.fieldRoot}
        fieldInputClassName={styles.fieldInputRow}
        info={info}
        label={label}
        labelClassName={styles.label}
        labelTextProps={{
          className: styles.labelText,
        }}
      >
        <div className={styles.valueBlock}>
          <span
            className={styles.swatch}
            style={{ backgroundColor: color || COLOR_PICKER_DEFAULT_HEX }}
          />
          {isValueInputFocused ? (
            isColorFormatHex(colorFormat) ? (
              <ColorPickerPopoverPreviewHexInput
                hexInputFocused={hexInputFocused}
                inputRef={valueInputRef}
                text={text}
                onBlur={handleHexInputBlur}
                onChange={handleHexInputChange}
                onFocus={handleHexInputFocus}
              />
            ) : (
              <ColorPickerPopoverPreviewRgbInputs
                groupRef={rgbGroupRef}
                inputRef={rgbInputRef}
                rgbB={rgbB}
                rgbFocusedChannel={rgbFocusedChannel}
                rgbG={rgbG}
                rgbR={rgbR}
                onBBlur={handleRgbChannelBlur}
                onBChange={handleBChange}
                onBFocus={handleBFocus}
                onGBlur={handleRgbChannelBlur}
                onGChange={handleGChange}
                onGFocus={handleGFocus}
                onRBlur={handleRgbChannelBlur}
                onRChange={handleRChange}
                onRFocus={handleRFocus}
              />
            )
          ) : (
            <ColorPickerPopoverPreviewValueTrigger
              color={color}
              colorFormat={colorFormat}
              rgb={rgb}
              onClick={handleValueTextTriggerClick}
              onKeyDown={handleValueTextTriggerKeyDown}
            />
          )}
        </div>
      </Field>
    </div>
  )
}

export default ColorPickerPopoverPreview
